import axios from 'axios';
import authHeader from '../auth-header';

import tokenHeader from '../token-header';

// const API_URL = 'https://localhost:9090/api/all/';
import baseUrl from '../base-url';

const API_URL = baseUrl()+"/api/all/";
const API_URL_FO = process.env.VUE_APP_BASE_URL_FO_USER+"/api/";

const getPelaporanSkp = 'pelaporan-skp';
const getPelaporanSkpDetail = 'riwayat_pelatihan_for_bo/';
const postPelaporanSkp = 'keanggotaan/pelaporan-skp';
const putPelaporanSkp = 'keanggotaan/pelaporan-skp/';
const deletePelaporanSkp = 'keanggotaan/pelaporan-skp/';
const exportDataPelaporan = 'pelaporan-skp-export';

class PelaporanSkpService {
    getPelaporanSkp(currentPage, pageSize, filter, kategori,tahun) {
        return axios.get(
            API_URL + getPelaporanSkp, {
                params: {
                    pageNo: currentPage,
                    pageSize: pageSize,
                    filter: filter,
                    idKategoriAnggota: kategori,
                    tahun : tahun                   
                },
                headers: authHeader()
            }
        );
    }

    getPelaporanSkpDetail(tahun, id_user) {
        return axios.get(
            API_URL_FO + getPelaporanSkpDetail + tahun + "/user/" + id_user, {
                headers: authHeader()
            }
        );
    }
 
    postKategoriAnggota(formData) {        
        return axios
        .post(
            API_URL + postKategoriAnggotaUrl,
            formData,
            { headers: authHeader() }
        );
    }

    putKategoriAnggota(formData) {
        var headers = authHeader(); 

        return axios
        .put(
            API_URL + putKategoriAnggota + formData.idKategoriAnggota, formData,
            { headers: authHeader() }
        );
    }

    deletePelaporanSkp(formData) {
        var headers = authHeader();

        return axios
            .delete(
                API_URL + deletePelaporanSkp + formData.id_pelaporan_skp,
                { headers: authHeader() }
            );
    }

    deleteKategoriAnggota(formData) {
        var headers = authHeader();

        return axios
            .delete(
                API_URL + deleteKategoriAnggota + formData.idKategoriAnggota,
                { headers: authHeader() }
            );
    }

    exportData(tahun, idKategoriAnggota) {
        return axios.get(API_URL + exportDataPelaporan + '?tahun=' + tahun + '&idKategoriAnggota=' + idKategoriAnggota, {
            headers: authHeader(),
            responseType: 'blob',
        });
    }

}

export default new PelaporanSkpService();